import { createFileRoute } from '@tanstack/react-router';
import { parseComplianceSearch } from '@/pages/Compliance/compliance-search';

export const Route = createFileRoute('/compliance/')({
  // `view` / `task` / `taskTenant` are declared and coerced to strings (see compliance-search.ts); every other key still passes through unchanged.
  validateSearch: parseComplianceSearch,
});
